import { Quill } from 'react-quill-new';

const Inline = Quill.import('blots/inline');

class CustomEmojiBlot extends Inline {
  static create(emoji) {
    let node = super.create();
    node.setAttribute('data-emoji', emoji);
    node.innerHTML = emoji;
    node.classList.add('ql-emoji');
    return node;
  }

  static value(node) {
    return {
      emoji: node.getAttribute('data-emoji')
    };
  }

  length() {
    return this.domNode.textContent.length;
  }
}

CustomEmojiBlot.blotName = 'emoji';
CustomEmojiBlot.tagName = 'span';

export default CustomEmojiBlot;
